import React, { memo } from 'react';
import { TableCell, TableRow, TablePagination as MuiTablePagination } from '@mui/material';
import { StyledBox } from './TablePagination.styles';

/**
 * Component for table pagination
 */
const TablePaginationComponent = memo(
  ({ totalCount, page, rowsPerPage, onPageChange, onRowsPerPageChange, tableColumnsCount }) => (
    <TableRow>
      <TableCell colSpan={tableColumnsCount} style={{ borderBottom: 'none' }}>
        <StyledBox>
          <MuiTablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={onPageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Rows:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
          />
        </StyledBox>
      </TableCell>
    </TableRow>
  )
);

export default TablePaginationComponent;
